export const centsToEuros = (cents: number | null | undefined) => (cents ?? 0) / 100;

export const eurosToCents = (euros: number) => Math.round(euros * 100);

export const roundNumberToFixed = (price: number, fixed: number) =>
  Math.round((price + Number.EPSILON) * Math.pow(10, fixed)) / Math.pow(10, fixed);

export const formatPrice = (price: number) => {
  return roundNumberToFixed(price, 2).toLocaleString("fr-FR", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  });
};
